module.exports = "<div *ngIf=\"mensaje\" \r\n\t\t[ngClass]=\"{ \r\n\t\t\t'alert':mensaje, \r\n\t\t\t'alert-success':mensaje.type==='success', \r\n\t\t\t'alert-info':mensaje.type==='info', \r\n\t\t\t'alert-warning':mensaje.type==='warning', \r\n\t\t\t'alert-danger':mensaje.type==='error',\r\n      'alert-dismissible': true}\" role=\"alert\">\r\n  <button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\" (click)=\"mensaje=false;\"><span aria-hidden=\"true\">&times;</span></button>\r\n\t{{mensaje.text}}\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/alerta/alerta.component.html
// module id = ./src/app/alerta/alerta.component.html
// module chunks = main